import {FACTIONS} from "../../../constants/factions";

export const DWARVES_QUOTES = [{
  quote: 'Горы помнят каждого, кто вошёл без карты. И не выпускают даже кости',
  author: 'Торгрим Глубокоруд, верховный гном-пластопрокладчик Шрердина',
  factionId: FACTIONS.DWARVES
}, {
  quote: 'Серебро и сталь — одно. Руда и кровь — одно. Горы и победа — одно. Запомни и живи',
  author: 'Хельга Боевая Наковальня, предводитель гномьего клана Стальных руд',
  factionId: FACTIONS.DWARVES
}, {
  quote: 'В горах эхо врёт. Эхо — это враг, который притворяется твоим голосом. Не верь ему, верь компасу',
  author: 'Корвел Тяжелоступ, глубинный гном-барон Хельмфосса',
  factionId: FACTIONS.DWARVES
}, {
  quote: 'Под землёй нет случайностей. Только невнимательность. Невнимательный гном становится частью руды',
  author: 'Гундр Копейщик, старший гном-рейнджер Броггарда',
  factionId: FACTIONS.DWARVES
}, {
  quote: 'Хорошая карта стоит дороже хорошего меча. Плохая карта стоит жизни',
  author: 'Фрости Глыбовласый, гном, пласт-капитан стражи Броггарда',
  factionId: FACTIONS.DWARVES
}, {
  quote: 'Мы не воюем с врагом. Мы воюем с горой. Враг лишь пытается помешать нам делать это эффективно',
  author: 'Стурм Кремнище, гном-отец клана Звонкого кайла',
  factionId: FACTIONS.DWARVES
}]